<script>
import axios from 'axios'
export default {
  name: 'baseQ',
  props: ['matter', 'question', 'answers', 'num'],
  data () {
    return {
      answer: {
        _id: null,
        matter: this.matter._id,
        ref: this.question.ref,
        num: this.num,
        atxt: ''
      },
      prevtxt: ''
    }
  },
  created: function () {
    let arr = this.answers[this.question.ref] // The array of answers for this question ref
    if (arr && arr.length >= this.num) {
      this.answer = arr[this.num - 1] // num starts at 1
      this.prevtxt = this.answer.atxt
    }
  },
  methods: {
    save: function () {
      let vm = this
      if (vm.prevtxt === vm.answer.atxt) return
      if (!vm.answer._id) { // New answer
        axios.post('/api/answers/new', vm.answer)
        .then(function (res) {
          vm.answer = res.data
          vm.prevtxt = res.data.atxt
          vm.$emit('saved', res.data)
        }).catch(err => { console.log(err) })
      } else {
        axios.post('/api/answers/update', vm.answer)
        .then(function (res) {
          vm.prevtxt = res.data.atxt
          vm.$emit('edited', res.data)
        }).catch(err => { console.log(err) })
      }
    },
    // Force the model update for Firefox
    quickSave: function (val) {
      this.answer.atxt = val
      this.save()
    }
  }
}
</script>



// WEBPACK FOOTER //
// base.vue?154d8e97